<template>
    <div>
        <v-img class="" style="width:300px;position: absolute; top:10%;margin-left: auto;margin-right: auto;left: 0;right: 0;" alt="logo" src="@/assets/img/logo-genl.svg"></v-img>
        <v-row class="w-100" style="height:100vh">
                    
            <v-col cols="12" md="6" lg="6" justify="center" class="mx-auto my-auto d-flex flex-column align-center"  >


                <v-card class="pa-6" elevation="8" style="width:80%" >
                    <v-card-title class="justify-center text-h5 text-uppercase" style="color:#AF8C55">Recuperar contraseña</v-card-title>
                    
                    <v-divider class="my-4"></v-divider>
                    
                    <v-card-subtitle class="justify-center d-flex mx-auto" >Captura el email con el que registraste tu cuenta</v-card-subtitle>

                    <v-card-text class="mt-4 d-flex flex-column " style="width:100%" >
                        <v-form align="center" class="" ref="passwordRescueForm" v-model="formValid">

                            <input type="email" class="form-ejemplo mb-4" id="" placeholder="Correo electrónico">

                            <v-row align="center" justify="center" style="width:75%;margin: auto" class="mb-16">
                                    <v-btn @click="1" :color="pantone" large class=" flex-fill mr-2 mt-2 white--text">Cancelar</v-btn>
                                    <v-btn @click="2" :color="pantoneBlack" large class=" flex-fill  mt-2 white--text">Continuar</v-btn>
                            </v-row>
                        </v-form>
                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>
    </div>

</template>

<script>
import {mapActions, mapState} from 'vuex'
import registerFormValidator from "bestgob-core/form/register.form.validator";

export default {
    data() {
        return {
            formValidator: registerFormValidator,
            request: {password: null, confirm_password: null, email: null, reset_token: null},

            formValid: false,
            showPassword: false,
            showRepeatPassword: false,
            pantone: '#B08C55',
            pantoneBlack: '#15212F'
        }
    },
    computed: {
        ...mapState({accountStore: state => state.account}),

         cssProps() {
            return {
              '--pantone': this.$vuetify.theme.themes.pantone,
              '--primary-color': this.$vuetify.theme.themes.light.primary
            }
        }
    },

    created() {
        this.$gtag.event('recuperar_contrasenia', { method: 'Google' }) // Google Analytics
    },

    mounted() {
        if (this.accountStore.loggedIn){
            this.$router.push({name: 'home'})
        }

        this.request.email = this.$route.query.email
        this.request.reset_token = this.$route.query.reset_token
    },

    methods: {
        ...mapActions('account', ['setNewUserPassword']),   

        updatePassword(){
            this.$refs.passwordRescueForm.validate()

            if (this.formValid){
                this.setNewUserPassword(this.request)
            }
        }
    },

};
</script>
<style>
    .form-ejemplo{
        padding: .9rem  1rem;
        margin: auto;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 0.3rem;
        display: block;
        width: 75%;
        color: #ff8400;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .form-ejemplo:focus-visible{
        outline: -webkit-focus-ring-color auto 0px !important;
    }
    .relative {position: relative}
    .absolute {position: absolute}
    .fb-native-button{width: 100%;}
    .fb-native-button button{
        height: 36px;
        background-image: none !important;
        padding: 0 !important;
        min-width: 0 !important;
        width: 100%
    }
    .fb-native-button button img, .fb-native-button button .spinner{display: none}
    
    .theme--light.v-divider {
        border-color: #ff840059;
        height: 3px !important;
        border-width: thin 0px  1px  0px;
    }
</style>
